import { ReactNode } from 'react';
import { Card } from '@mantine/core';

export const UiTicket = ({
  children,
}: {
  children?: ReactNode | ReactNode[];
}) => {
  return (
    <Card
      p={16}
      shadow="xs"
      style={{ position: 'initial', border: '1px solid #b8b8b8' }}
    >
      <Card.Section withBorder inheritPadding py="xs">
        {children}
      </Card.Section>
    </Card>
  );
};
